/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import React, { useEffect } from 'react';
import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Skeleton from '../Skeleton';
import Motorbike from '../Motorbike.gif';

// Higher-order component to wrap components with AOS animation
const withAOS = (WrappedComponent) => {
  return function WithAOS(props) {
    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: false,
        delay: 100,
        anchorPlacement: 'top-center',
      });
    }, []);

    return <WrappedComponent {...props} />;
  };
};

// Directly imported components
import FaqAccordion from '../components/Feature/SmartXonnect/FaqAccordion/FaqAccordion';
import StickyHeader from '../components/Feature/SmartXonnect/StickyHeader/StickyHeader';
import InfoSection from '../components/Feature/SmartXonnect/InfoSection/InfoSection';
import FooterNav from '../components/Feature/SmartXonnect/Footer/FooterNav';
import FooterBottom from '../components/Feature/SmartXonnect/Footer/FooterBottom';
import SmartXonnectLayout from '../components/Project/Layouts/SmartXonnect/SmartXonnectLayout';
import WhatsTrendingCarousel from '../components/Feature/SmartXonnect/CarouselFolds/WhatsTrendingCarousel';
import BeforeTheRideCarousel from '../components/Feature/SmartXonnect/CarouselFolds/BeforeTheRideCarousel';
import OnTheWaySlider from '../components/Feature/SmartXonnect/CarouselFolds/OnTheWaySlider';
import FeatureComparison from '../components/Feature/SmartXonnect/FeatureComparison/FeatureComparison';
import VideoPlaylist from '../components/Feature/SmartXonnect/VideoPlaylist/VideoPlaylist';
import AlwaysConnectedSlider from '../components/Feature/SmartXonnect/CarouselFolds/AlwaysConnectedSlider';
import MobileDownloadSection from '../components/Feature/SmartXonnect/MobileDownloadSection/MobileDownloadSection';
import HeroVideoBanner from '../components/Feature/SmartXonnect/HeroVideoBanner/HeroVideoBanner';
import TwoColumnFeatureBanner from '../components/Feature/SmartXonnect/TwoColumnFeatureBanner/TwoColumnFeatureBanner';
import VideoBanner from '../components/Feature/SmartXonnect/VideoBanner/VideoBanner';
import SmartXonnectUsage from '../components/Feature/SmartXonnect/SmartXonnectUsage/SmartXonnectUsage';


// Noise Component 

import NoiseInfoSection from '../components/Feature/Noise/InfoSection/NoiseInfoSection';
import NoiseBeforeTheRideCarousel from '../components/Feature/Noise/CarouselFolds/NoiseBeforeTheRideCarousel';
import NoiseAlwaysConnectedSlider from '../components/Feature/Noise/CarouselFolds/NoiseAlwaysConnectedSlider';
import NoiseOnTheWaySlider from '../components/Feature/Noise/CarouselFolds/NoiseOnTheWaySlider';
import NoiseTwoColumnFeatureBanner from '../components/Feature/Noise/TwoColumnFeatureBanner/NoiseTwoColumnFeatureBanner';
import NoiseRideConnected from '../components/Feature/Noise/NoiseRide/NoiseRideConnected';
import NoiseVideoBanner from '../components/Feature/Noise/VideoBanner/NoiseVideoBanner';

// Wrapping components with AOS
const components = new Map();
components.set('FaqAccordion', withAOS(FaqAccordion));
components.set('SmartXonnectUsage', withAOS(SmartXonnectUsage));
components.set('VideoBanner', withAOS(VideoBanner));
components.set('StickyHeader', withAOS(StickyHeader));
components.set('InfoSection', withAOS(InfoSection));
components.set('FooterNav', withAOS(FooterNav));
components.set('FooterBottom', withAOS(FooterBottom));
components.set('SmartXonnectLayout', withAOS(SmartXonnectLayout));
components.set('WhatsTrendingCarousel', withAOS(WhatsTrendingCarousel));
components.set('BeforeTheRideCarousel', withAOS(BeforeTheRideCarousel));
components.set('OnTheWaySlider', withAOS(OnTheWaySlider));
components.set('FeatureComparison', withAOS(FeatureComparison));
components.set('VideoPlaylist', withAOS(VideoPlaylist));
components.set('AlwaysConnectedSlider', withAOS(AlwaysConnectedSlider));
components.set('MobileDownloadSection', withAOS(MobileDownloadSection));
components.set('HeroVideoBanner', withAOS(HeroVideoBanner));
components.set('TwoColumnFeatureBanner', withAOS(TwoColumnFeatureBanner));

//Noise component 
components.set('NoiseInfoSection', withAOS(NoiseInfoSection));
components.set('NoiseBeforeTheRideCarousel', withAOS(NoiseBeforeTheRideCarousel));
components.set('NoiseAlwaysConnectedSlider', withAOS(NoiseAlwaysConnectedSlider));
components.set('NoiseOnTheWaySlider', withAOS(NoiseOnTheWaySlider));
components.set('NoiseTwoColumnFeatureBanner', withAOS(NoiseTwoColumnFeatureBanner));
components.set('NoiseRideConnected', withAOS(NoiseRideConnected));
components.set('NoiseVideoBanner', withAOS(NoiseVideoBanner));
// Component factory
const componentBuilder = new ComponentBuilder({ components });
export const componentFactory = componentBuilder.getComponentFactory();